<template>
    <v-list-item>
        <template #prepend>
            <slot name="prepend">
                <template v-if="prepend">
                    <v-icon v-if="prepend == 'icon'" :color="iconColor">{{ icon }}</v-icon>
                    <k-tool-tip
                        v-else-if="prepend == 'tooltipIcon'"
                        :color="iconColor"
                        :icon="icon"
                        :text="tooltipText">
                        <template #activator>
                            <slot name="tooltipBody"></slot>
                        </template>
                    </k-tool-tip>
                </template>
            </slot>

        </template>
        <template #append>
            <slot name="append">
                <template v-if="append">
                    <v-icon v-if="append == 'icon'" :color="iconColor">{{ icon }}</v-icon>
                    <k-tool-tip
                        v-else-if="append == 'tooltipIcon'"
                        :color="iconColor"
                        :icon="icon"
                        :text="tooltipText">
                        <template #activator>
                            <slot name="tooltipBody"></slot>
                        </template>
                    </k-tool-tip>
                </template>
            </slot>

        </template>
        <v-list-item-title>
            <slot name="title"></slot>
        </v-list-item-title>
        <v-list-item-subtitle>
            <slot name="subtitle"></slot>
        </v-list-item-subtitle>
        <slot name="text">{{ text }}</slot>
        <v-list-item-action>
            <slot name="action"></slot>
        </v-list-item-action>
    </v-list-item>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue"
import type {TColor} from "@/components/generics/types/TColor";
import type {TIconType} from "./types/TIconType";
import KToolTip from "@/components/dds/KToolTip/KToolTip.vue";

export default defineComponent({
    components: {KToolTip},
    props: {
        prepend: {
            type: String as PropType<TIconType>
        },
        append: {
            type: String as PropType<TIconType>
        },
        icon: {
            type: String
        },
        iconColor: {
            type: String as PropType<TColor>,
            default: 'kpmgPrimary-900'
        },
        tooltipText: {
            type: String,
        },
        text: {
            type: String,
        }
    },
    setup() {
        return {}
    },
})
</script>
